<template>
  <div class="clearfix">
    <a-upload
      :action="uploadImgUrl"
      list-type="picture-card"
      :file-list="fileList"
      :multiple="allowMultiple"
      :headers="headers"
      @preview="handlePreview"
      @change="handleChange"
      :before-upload="beforeUpload"
    >
      <!-- -->
      <div v-if="fileList.length < fileListLength">
        <a-icon type="plus" />
        <div class="ant-upload-text">
          <!-- Upload -->
        </div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'UploadFileListCmp',
  props: {
    imgUrl: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'image',
    },
    fileListLength: {
      type: Number,
      default: null,
    },
    fList: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    function getBase64(img, callback) {
      const reader = new FileReader()
      reader.addEventListener('load', () => callback(reader.result))
      reader.readAsDataURL(img)
    }
    return {
      allowMultiple: true,
      loading: false,
      open: false,
      ossUrl: process.env.VUE_APP_OSS_URL,
      uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*',
      },
      previewVisible: false,
      previewImage: '',
      fileList: this.fList,
      newFileList: [],
    }
  },
  mounted() {},
  created() {
    console.log(this.fList, this.skType + '===============showFileList')
  },
  methods: {
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    handleChange({ fileList }) {
      this.fileList = fileList
      const fileList_ = []
      let fileObj = {}
      for (const f of fileList) {
        if (f && typeof f.name !== 'undefined') {
          fileObj = f
          fileList_.push(fileObj)
        } else if (f && f.response.data.ossId && typeof f.response !== 'undefined') {
          const fData = f.response.data
          fileObj.name = fData.fileName
          fileObj.status = 'done'
          fileObj.uid = fData.ossId
          fileObj.url = process.env.VUE_APP_OSS_URL + fData.fileName
          fileList_.push(fileObj)
        }
      }
      this.newFileList = fileList_
      this.$emit('fileListUrlFn', this.newFileList, this.skType)
    },
    beforeUpload(file) {
      console.log(file.type, 'file.type')
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf'
      if (!isJpgOrPng) {
        this.$message.error('您可以上传jpeg/jpg/png/dpf!')
      }
      // const isLt2M = file.size / 1024 / 1024 < 2
      // if (!isLt2M) {
      //   this.$message.error('Image must smaller than 2MB!')
      // }
      return isJpgOrPng
      // && isLt2M
    },
  },
  watch: {
    fList: {
      handler(newVal, oldVal) {
        console.log(this.fileList, 'fList', oldVal)
        this.fileList = newVal
      },
      deep: true,
    },
  },
}
</script>
<style lang="less" scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
